export class GroupUpdateModel {
	id: string;
}
